import React from 'react';
import styled from 'astroturf/react';

import type { ArmSpec } from '../armRegistry';

const WhyFreeLine = styled.p`
  max-width: 340px;
  margin: var(--spacing-xxs-8, 8px) auto 0;
  font-family: var(--type-font-family-sans-serif, 'DM Sans', sans-serif);
  font-size: 14px;
  line-height: 1.4;
  color: var(--text-primary, #26262b);
  text-align: center;
`;

const WHY_FREE_COPY =
  'Papers on Academia are free to read. Authors share them here ' +
  'to help accelerate research.';

const WhyFreeConfession: React.FC = () => (
  <WhyFreeLine>{WHY_FREE_COPY}</WhyFreeLine>
);

export const whyFreeSpec: ArmSpec = {
  slots: () => ({ underHeader: <WhyFreeConfession /> }),
};
